import { disabled, FieldTree, required, schema, validate } from '@angular/forms/signals';
import { COUNTRIES } from '../../../shared-lazy/components/join-form/countries';
import { AUTH_USER_ROLES, UserDetails } from '../models';

const OTHER_COUNTRY = 'Other';
const NAME_IS_EMAIL_ERROR = { kind: 'nameIsEmail' } as const;

export interface ProfileFormModel {
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  countryOther: string;
  role: string;
}

export function profileFormModel(user: UserDetails): ProfileFormModel {
  const existingCountry = user.country || '';
  const countryIsKnown = COUNTRIES.includes(existingCountry) && existingCountry !== OTHER_COUNTRY;
  const existingRole = user.roles?.[0];
  return {
    firstName: user.given_name || '',
    lastName: user.family_name || '',
    email: user.email || '',
    country: countryIsKnown ? existingCountry : existingCountry ? OTHER_COUNTRY : '',
    countryOther: countryIsKnown ? '' : existingCountry,
    role: AUTH_USER_ROLES.includes(existingRole) ? existingRole : '',
  };
}

export const profileFormSchema = schema<ProfileFormModel>((path) => {
  for (const name of [path.firstName, path.lastName]) {
    required(name);
    validate(name, ({ value }) => (value().includes('@') ? NAME_IS_EMAIL_ERROR : undefined));
  }
  disabled(path.email);
  required(path.country);
  required(path.countryOther, { when: ({ valueOf }) => valueOf(path.country) === OTHER_COUNTRY });
  required(path.role);
});

export function isOtherCountry(value: ProfileFormModel): boolean {
  return value.country === OTHER_COUNTRY;
}

export function profileCountry(value: ProfileFormModel): string {
  return isOtherCountry(value) ? value.countryOther : value.country;
}

export function hasProfileError(field: FieldTree<string>, kind: 'required' | typeof NAME_IS_EMAIL_ERROR.kind): boolean {
  return field()
    .errors()
    .some((error) => error.kind === kind);
}
